import { useState } from "react";

const faqs = [
  {
    question: "What are Paladin's office hours?",
    answer:
      "Our team is available Monday through Friday, 9:00 AM – 5:00 PM. We are closed on Saturdays and Sundays. If you need to reach us outside of office hours, you can send an email to support@paladinbusinessservices.net and an agent will get back to you on the next business day.",
  },
  {
    question: "How can I contact Paladin?",
    answer:
      "You can reach us through any of the following: Phone: 805-692-6900 | Fax: 805-830-1680 | Email: support@paladinbusinessservices.net | Address: 3787 Transport ST Suite A7 Box #5, Ventura, CA 93003. We're happy to assist through whichever channel is most convenient for you.",
  },
  {
    question: "Where is Paladin's office located?",
    answer:
      "Our office is located at 3787 Transport ST Suite A7 Box #5, Ventura, CA 93003. We welcome visits during business hours (Monday–Friday, 9:00 AM – 5:00 PM) and are also available by phone and email for clients who prefer remote assistance.",
  },
];

function FaqItem({ question, answer, isOpen, onToggle }) {
  return (
    <div
      className={`border transition-all duration-200 overflow-hidden ${
        isOpen
          ? "border-blue-dark border-opacity-25 bg-white-pure shadow-sm"
          : "border-blue-dark border-opacity-8 bg-white-warm hover:bg-white-pure hover:border-opacity-18"
      }`}
      style={{ borderRadius: "16px" }}
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between px-7 py-5 text-left group"
        aria-expanded={isOpen}
      >
        <span
          className={`font-constantia font-bold pr-5 transition-colors duration-150 ${
            isOpen ? "text-blue-dark" : "text-blue-dark opacity-75 group-hover:opacity-100"
          }`}
          style={{ fontSize: "15.5px", lineHeight: "1.45" }}
        >
          {question}
        </span>

        <span
          className={`flex-shrink-0 w-7 h-7 rounded-full border flex items-center justify-center ${
            isOpen
              ? "bg-blue-dark border-blue-dark text-white-pure"
              : "border-blue-dark border-opacity-20 text-blue-dark group-hover:border-opacity-40"
          }`}
          style={{
            fontSize: "17px",
            lineHeight: 1,
            transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
            transition: "transform 0.25s ease, background 0.2s, border-color 0.2s",
          }}
          aria-hidden="true"
        >
          +
        </span>
      </button>

      <div
        style={{
          display: "grid",
          gridTemplateRows: isOpen ? "1fr" : "0fr",
          transition: "grid-template-rows 0.28s ease",
        }}
      >
        <div style={{ overflow: "hidden" }}>
          <div className="px-7 pb-6">
            <div className="h-px bg-blue-dark opacity-8 mb-4" />
            <p
              className="font-constantia text-black-deep opacity-60 leading-relaxed"
              style={{ fontSize: "15px" }}
            >
              {answer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function ContactFaqsSection({ searchQuery = "" }) {
  const [openIndex, setOpenIndex] = useState(null);

  const filtered = faqs.filter(
    (faq) =>
      faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
      faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (filtered.length === 0) return null;

  return (
    <section id="contact" className="bg-white-pure w-full py-16 px-6">
      <div className="max-w-3xl mx-auto">

        <div className="flex items-center gap-3 mb-8">
          <div
            className="bg-blue-dark opacity-50 rounded-full"
            style={{ width: "2px", height: "20px" }}
          />
          <span
            className="font-cinzel text-blue-dark uppercase"
            style={{ fontSize: "10px", letterSpacing: "0.22em" }}
          >
            Contact &amp; Office
          </span>
          {searchQuery && (
            <span
              className="ml-auto font-constantia text-blue-dark opacity-35"
              style={{ fontSize: "11px" }}
            >
              {filtered.length} result{filtered.length !== 1 ? "s" : ""}
            </span>
          )}
        </div>

        <div className="flex flex-col gap-3">
          {filtered.map((faq, index) => (
            <FaqItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}